import { ArrowDown, ArrowUp, Minus } from "lucide-react";

export const Bloc = ({ titre, sous, testId, children, action }) => (
  <section className="at-card p-5 min-w-0 at-rise" data-testid={testId}>
    <div className="flex items-start justify-between gap-3 mb-3">
      <div className="min-w-0"><p className="font-bold">{titre}</p>{sous && <p className="text-xs at-muted">{sous}</p>}</div>
      {action}
    </div>
    {children}
  </section>
);

export const Chiffre = ({ label, valeur, sous, testId }) => (
  <div className="at-soft p-3 min-w-0">
    <p className="text-[11px] at-muted break-words">{label}</p>
    <p className="text-xl font-bold tabular-nums" data-testid={testId}>{valeur}</p>
    {sous && <p className="text-[11px] at-muted break-words">{sous}</p>}
  </div>
);

export const Barre = ({ pct, couleur = "var(--accent)" }) => (
  <div className="h-2 at-pill overflow-hidden" style={{ background: "var(--surface-2)" }}>
    <span className="block h-full at-pill" style={{ width: `${Math.max(0, Math.min(100, pct || 0))}%`, background: couleur, transition: "width .5s ease" }} />
  </div>
);

export const Fleche = ({ v, testId }) => {
  const Icone = v > 0 ? ArrowUp : v < 0 ? ArrowDown : Minus;
  return <Icone size={15} data-testid={testId} style={{ color: v > 0 ? "var(--success)" : v < 0 ? "var(--danger)" : "var(--muted)" }} aria-label={v > 0 ? "en hausse" : v < 0 ? "en baisse" : "stable"} />;
};

export const pct = (v) => (v === null || v === undefined ? "—" : `${v} %`);
export const duree = (s) => `${Math.floor((s || 0) / 3600)} h ${String(Math.floor(((s || 0) % 3600) / 60)).padStart(2, "0")}`;
export const heure = (iso) => (iso ? new Date(iso).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" }) : "—");
export const Vide = ({ texte = "Aucune donnée pour le moment.", testId }) => <p className="text-sm at-muted" data-testid={testId}>{texte}</p>;
